import React from "react";
import {Col, FloatingLabel, Form, FormControl} from "react-bootstrap";
import {useTranslate} from "@tolgee/react";
import {MultiSelect} from "primereact/multiselect";
import {MultiSelectFieldProps} from "../FormTypes";
import {useFormsContext} from "../Forms";
import {SelectItem} from "primereact/selectitem";

export const MultiSelectDropDown = <T,>({name, inlineSize = 12, hide, label, multiSelectOptions}:MultiSelectFieldProps<T>) => {
    const t = useTranslate();
    const { data, errorState, onBlur, onValueChange } = useFormsContext<T>();
    let fieldError = errorState[name];



  return<Col sm={inlineSize} className="my-1 w-full">
      <div className="mb-1 ml-1 mr-1 flex flex-row w-full">
        <MultiSelect className="w-full" value={data[name]} options={multiSelectOptions} onChange={(e) => {onValueChange(name, e.value)}} optionLabel="name" placeholder={label} display="chip" />
      </div>
  </Col>;
};
